import { ActionStatus } from '../../types'

export function computeVehicleAssignmentPermission(): ActionStatus {
  return 'enabled'
}
